import { SET_USER_REALM } from './types';
import { getViewStyle } from './view';
import { get } from 'global/lib/lodash';

export default function (realm) {
  return (dispatch, getState) => {
    const prev = get(getState(), 'auth.realm');
    const prevId = prev == null ? null : get(prev, 'id');
    const nextId = realm == null ? null : get(realm, 'id');
    // Same location: do not refetch account-settings / rebuild the theme.
    // Native uncover used to re-apply the picker realm and flash THEMEDEFAULTS
    // before branded colors landed.
    if (prevId == nextId) {
      return;
    }
    const id = get(realm, 'id', get(getState(), 'auth.user.realm.id'));
    dispatch(getViewStyle(id));
    dispatch({ type: SET_USER_REALM, realm });
    // Native WebView: keep native location in sync on every global realm change,
    // including while native Assessments is showing. No-ops when TLM is absent.
    try {
      get(window, 'TLM.setNativeRealm', () => 0)(realm || null);
    } catch (err) {
      console.warn(err);
    }
  };
}
